import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';

export interface NotificationToastData {
  title: string;
  message?: string;
  redirectUrl?: string;
}

@Component({
  selector: 'app-notification-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notification-toast.component.html',
  styleUrls: ['./notification-toast.component.scss'],
  // None required — snackbar renders inside a CDK overlay portal outside
  // the Angular component tree, so Emulated encapsulation has no effect there.
  encapsulation: ViewEncapsulation.None,
})
export class NotificationToastComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificationToastData,
    public snackBarRef: MatSnackBarRef<NotificationToastComponent>,
    private router: Router,
  ) {}

  navigate(): void {
    if (this.data.redirectUrl) {
      this.router.navigateByUrl(this.data.redirectUrl);
      this.snackBarRef.dismiss();
    }
  }
}
